import { Backdrop, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { useMemo } from 'react'
import { createPortal } from 'react-dom'

import { CloseIcon } from 'shared'
import OnboardingMenuStep from '../OnboardingMenuStep'
import { IOnboardingMenuStep } from '..'
import { useIsMobile } from 'utils/hooks/useIsMobile'

const useStyles = makeStyles((theme) => ({
  menu: {
    position: 'fixed',
    left: '264px',
    bottom: '64px',
    zIndex: 1400,
    boxShadow: '0px 4px 13px 0px rgba(105, 102, 107, 0.43)',
    width: 290,
    borderRadius: '16px',
    padding: '24px',
    backgroundColor: theme.palette.common.white,

    [theme.breakpoints.down('sm')]: {
      left: '50%',
      bottom: '50%',
      transform: 'translate(-50%, 50%)',
    },
  },
  closeIcon: {
    color: theme.palette.primary.main,
  },
}))

const OnboardingMenu = ({
  isOpen,
  onClose,
  onStepClick,
  steps,
}: {
  isOpen: boolean
  onClose: () => void
  onStepClick: () => void
  steps: IOnboardingMenuStep[]
}) => {
  const classes = useStyles()

  const isMobile = useIsMobile()

  const getActiveIndex = useMemo(() => {
    return steps.findIndex((el) => !el.checked)
  }, steps)

  if (!isOpen) return null

  return createPortal(
    <>
      <Backdrop open={isMobile} sx={{ zIndex: 1301 }} />
      <Grid className={classes.menu}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography sx={{ fontWeight: '700', fontSize: '20px' }}>
            Get Started
          </Typography>
          <Grid container width="auto">
            <CloseIcon onClick={onClose} className={classes.closeIcon} />
          </Grid>
        </Grid>
        <Grid container flexDirection="column" gap={2}>
          {steps.map((el, index) => {
            if (el.hidden) return null
            return (
              <OnboardingMenuStep
                key={el.id}
                isActive={index === getActiveIndex && !el.checked}
                onStepClick={onStepClick}
                {...el}
              />
            )
          })}
        </Grid>
      </Grid>
    </>,
    document.body
  )
}

export default OnboardingMenu
